import { render, staticRenderFns } from "./page_content_editor.vue?vue&type=template&id=6d623da5&"
import script from "./page_content_editor.vue?vue&type=script&lang=js&"
export * from "./page_content_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d623da5')) {
      api.createRecord('6d623da5', component.options)
    } else {
      api.reload('6d623da5', component.options)
    }
    module.hot.accept("./page_content_editor.vue?vue&type=template&id=6d623da5&", function () {
      api.rerender('6d623da5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/page-content/page_content_editor.vue"
export default component.exports